import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { Input, Button } from '@salesforce/design-system-react';

import './ProfileMetadataRow.scss';

class ProfileMetadataRow extends Component {
  handleTagTypeChange(event, { value }) {
    const tag = {
      tagType: value,
      tagValue: this.props.tagValue,
      id: this.props.id
    };
    this.props.actions.updateProfileTag(tag);
  }

  handleTagValueChange(event, { value }) {
    const tag = {
      tagType: this.props.tagType,
      tagValue: value,
      id: this.props.id
    };
    this.props.actions.updateProfileTag(tag);
  }
  render() {
    return (
      <div className="metadata-row-container">
        <Input
          className="tag-input"
          label="Tag"
          value={this.props.tagType}
          onChange={this.handleTagTypeChange.bind(this)}
        />
        <Input
          className="tag-input"
          label="Value"
          value={this.props.tagValue}
          onChange={this.handleTagValueChange.bind(this)}
        />
        <Button
          className="delete-button"
          iconCategory="utility"
          iconName="delete"
          variant="icon"
          onClick={() => this.props.onDelete(this.props.id)}
        />
      </div>
    );
  }
}

ProfileMetadataRow.propTypes = {
  tagType: PropTypes.string,
  tagValue: PropTypes.string,
  id: PropTypes.string,
  onDelete: PropTypes.func,
  intl: intlShape.isRequired
};

export default injectIntl(ProfileMetadataRow);
